import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const GetStartButton = ({
  onClick,
  className = '',
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="success"
      onClick={onClick}
      disabled={disabled}
      className={`mb-2 px-4 ${className}`}
    >
      {t('Get Started Now')}
    </Button>
  );
};

export default GetStartButton;
